module.exports = __webpack_public_path__ + "img/Contacts copy.82d17a78.svg";